import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Tooltip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useAccount } from 'shared/domains/users';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { useFilter } from './useFilter';
export const ProjectMyProjectsFilter = withFilterErrorBoundary(() => {
    var _a;
    const { data } = useAccount();
    const currentUserId = (_a = data === null || data === void 0 ? void 0 : data.userId) !== null && _a !== void 0 ? _a : '';
    const { value, applyValue, resetValue } = useFilter('metadataProjectProjectOwner');
    const checked = !(value === null || value === void 0 ? void 0 : value.in) ? false : value.in.includes(currentUserId);
    const handleClick = () => {
        if (checked) {
            resetValue();
        }
        else {
            applyValue({ in: [currentUserId] });
        }
    };
    return (<Tooltip title={t({
            message: 'Only show projects where I am a project owner',
            comment: 'Insights: Project my projects filter tooltip',
        })}>
      <Button size="small" appearance="secondary" onClick={handleClick}>
        {checked ? (<Falcon icon="square-check" sourceConfig={{ family: 'classic', style: 'solid' }}/>) : (<Falcon icon="square"/>)}
        <Trans comment="Insights: Project my projects filter label">My projects</Trans>
      </Button>
    </Tooltip>);
});
